import { MpsGridTemplate } from '@mps/mps-kit/mps-grid';

export const hpc_grid_templates: Record<string, MpsGridTemplate> = {
  default: {
    id: 'default',
  },

  'grid:hpc-view': {
    columns: [1, 2, 3],
    cardContainer: {
      xsBackground: 'var(--mps-clr-bg-card-white)',
      xsPadding: 'size.medium',
      xsElevation: 'size.small',
      xsBorderRadius: 'size.medium',
    },
  },
  'grid:hpc-view-projection': {
    columns: [1, 2, 3],
    cardContainer: {
      xsBackground: 'var(--mps-clr-bg-card-white)',
      xsPadding: 'size.medium',
      xsElevation: 'size.small',
      xsBorderRadius: 'size.medium',
    },
  },
  'grid:hpc-view-formation': {
    columns: [1, 2, 3],
    cardContainer: {
      xsBackground: 'var(--mps-clr-bg-card-white)',
      xsPadding: 'size.medium',
      xsElevation: 'size.small',
      xsBorderRadius: 'size.medium',
      style: {
        width: '500px',
      },
    },
  },
};
